import { render, staticRenderFns } from "./HojaFirmasTemplate.vue?vue&type=template&id=8ac5fdce"
import script from "./HojaFirmasTemplate.vue?vue&type=script&lang=js"
export * from "./HojaFirmasTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ac5fdce')) {
      api.createRecord('8ac5fdce', component.options)
    } else {
      api.reload('8ac5fdce', component.options)
    }
    module.hot.accept("./HojaFirmasTemplate.vue?vue&type=template&id=8ac5fdce", function () {
      api.rerender('8ac5fdce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/HojaFirmasTemplate.vue"
export default component.exports